import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    ja: {
        category: {
            "Clear Filters": "フィルターを解除",
            "Not confirmed": "未確認",
            "Coming soon": "近日公開",
            "Big-Eyed": "目が大きい動物",
            "Canines": "イヌ科の動物",
            "Diving": "潜水できる動物",
            "Egg-Laying": "産卵する動物",
            "Felines": "ネコ科の動物",
            "Fluffy": "毛深い動物",
            "Flying": "飛べる動物",
            "Horned": "頭に角がある動物",
            "Long-Tailed": "長い尾の動物",
            "Meat-Eating": "肉を食べる動物",
            "Plant-Eating": "植物を食べる動物",
        },
        character: {
            "Bacon": "ベーコン",
            "Barbara": "バーバラ",
            "Barbie": "バービー",
            "Bob": "ボブ",
            "Bruce": "ブルース",
            "Buddy": "バディ",
            "Cabbage Dog": "ハクサイヌ",
            "Carrot": "キャロット",
            "Coco": "ココ",
            "Curtis": "カーティス",
            "Dodo": "ドド",
            "Dundun": "ドゥンドゥン",
            "Fluffy": "フラッフィ",
            "Fubao": "フーバオ",
            "Fuguee": "フギー",
            "Garfat": "ガーファット",
            "Googoo": "グーグー",
            "Gopher": "ゴーファー",
            "Hachi": "ハチ",
            "Hammer": "ハマー",
            "Harry": "ハリー",
            "Hoot": "フート",
            "Kato": "ケイトー",
            "Kiko": "キコ",
            "Kola": "コーラ",
            "Levi": "レヴィ",
            "Lloyd": "ロイド",
            "Logan": "ローガン",
            "Lotus": "ロータス",
            "Lou": "ルー",
            "Lamar": "ラマー",
            "Macchiato": "マキアート",
            "Maneki": "マネキ",
            "Max": "マックス",
            "Milky": "ミルキー",
            "Moonmoon": "ムーンムーン",
            "Morse": "モース",
            "Miu": "ミウ",
            "Naru": "ナル",
            "Nemo": "ニモ",
            "Noodle": "ヌードル",
            "Om Nom": "オムノム",
            "Ori": "オリ",
            "Otta": "オッタ",
            "Pensky": "ペンスキー",
            "Raven": "レイヴン",
            "Roach": "ローチ",
            "Ron": "ロン",
            "Sam": "サム",
            "Shin": "しんちゃん",
            "Snow": "スノー",
            "Skipper": "スキッパー",
            "Sparky": "スパーキー",
            "Spike": "スパイク",
            "Stella": "ステラ",
            "Sunday": "サンデー",
            "Sunny": "サニー",
            "The Lamb": "The Lamb",
            "Tiagra": "ティアグラ",
            "Tuskarr": "タスカー",
            "Tyrex": "タイレックス",
            "Underbite": "アンダーバイト",
            "Uni": "ユニ",
            "Valiente": "バリエンテ",
            "Yurusa": "ユルサ"
        }
    },
    th: {
        category: {
            "Clear Filters": "ล้างตัวกรอง",
            "Not confirmed": "ไม่ได้รับการยืนยัน",
            "Coming soon": "เร็ว ๆ นี้",
            "Big-Eyed": "สัตว์ที่มีดวงตาใหญ่",
            "Canines": "สัตว์วงศ์สุนัข",
            "Diving": "สัตว์ที่ดำน้ำได้",
            "Egg-Laying": "สัตว์วางไข่",
            "Felines": "สัตว์วงศ์แมว",
            "Fluffy": "สัตว์ขนฟู",
            "Flying": "สัตว์ที่บินได้",
            "Horned": "สัตว์ที่มีเขา",
            "Long-Tailed": "สัตว์ที่มีหางยาว",
            "Meat-Eating": "สัตว์ที่กินเนื้อ",
            "Plant-Eating": "สัตว์ที่กินพืช",
        },
        character: {
            "Bacon": "เบคอน",
            "Barbara": "บาร์บาร่า",
            "Barbie": "บาร์บี้",
            "Bob": "บ๊อบ",
            "Bruce": "บรูซ",
            "Buddy": "บัดดี้",
            "Cabbage Dog": "สุนัขผักกาดขาว",
            "Carrot": "แคร์รอต",
            "Coco": "โคโค่",
            "Curtis": "เคอร์ติส",
            "Dodo": "โดโด",
            "Dundun": "ดันดัน",
            "Fluffy": "ฟลัฟฟี่",
            "Fubao": "ฟู่เปา",
            "Fuguee": "ฟูกี",
            "Garfat": "การ์แฟต",
            "Googoo": "กูกู",
            "Gopher": "โกเฟอร์",
            "Hachi": "ฮาจิ",
            "Hammer": "แฮมเมอร์",
            "Harry": "แฮรี่",
            "Hoot": "ฮู๊ต",
            "Kato": "เคโต้",
            "Kiko": "คิโกะ",
            "Kola": "โคล่า",
            "Levi": "ลีวาย",
            "Lloyd": "ลอยด์",
            "Logan": "โลแกน",
            "Lotus": "โลตัส",
            "Lou": "ลู",
            "Lamar": "ลามาร์",
            "Macchiato": "มัคคียาโต",
            "Maneki": "มาเนกิ",
            "Max": "แม็กซ์",
            "Milky": "มิลค์กี้",
            "Moonmoon": "มูนมูน",
            "Morse": "มอร์ส",
            "Miu": "มิว",
            "Naru": "นารุ",
            "Nemo": "นีโม",
            "Noodle": "บะหมี่",
            "Om Nom": "โอม นอม",
            "Ori": "โอริ",
            "Otta": "ออตต้า",
            "Pensky": "เพนสกี้",
            "Raven": "เรเวน",
            "Roach": "โรช",
            "Ron": "รอน",
            "Sam": "แซม",
            "Shin": "ชิน",
            "Snow": "สโนว์",
            "Skipper": "สกิปเปอร์",
            "Sparky": "สปาร์กี้",
            "Spike": "สไปค์",
            "Stella": "สเตลล่า",
            "Sunday": "ซันเดย์",
            "Sunny": "ซันนี่",
            "The Lamb": "The Lamb",
            "Tiagra": "ติอากรา",
            "Tuskarr": "ทัสการ์",
            "Tyrex": "ไทเร็กซ์",
            "Underbite": "อันเดอร์ไบต์",
            "Uni": "ยูนิ",
            "Valiente": "บาลิเอนเต",
            "Yurusa": "ยูรุซ่า",
        }
    },
    fr: {
        category: {
            "Clear Filters": "Effacer les filtres",
            "Not confirmed": "Non confirmé",
            "Coming soon": "Bientôt",
            "Big-Eyed": "Gros yeux",
            "Canines": "Canins",
            "Diving": "Plongeurs",
            "Egg-Laying": "Pondant des œufs",
            "Felines": "Félins",
            "Fluffy": "Duveteux",
            "Flying": "Volants",
            "Horned": "Cornus",
            "Long-Tailed": "Longue queue",
            "Meat-Eating": "Carnivores",
            "Plant-Eating": "Herbivores",
        },
    },
    "zh-Hans": {
        category: {
            "Clear Filters": "清除筛选",
            "Not confirmed": "未确认",
            "Coming soon": "即将推出",
            "Big-Eyed": "大眼睛动物",
            "Canines": "犬科动物",
            "Diving": "潜水动物",
            "Egg-Laying": "下蛋动物",
            "Felines": "猫科动物",
            "Fluffy": "毛茸茸动物",
            "Flying": "飞行动物",
            "Horned": "有角动物",
            "Long-Tailed": "尾巴长动物",
            "Meat-Eating": "食肉动物",
            "Plant-Eating": "食草动物",
        },
        character: {
            "Bacon": "培根",
            "Barbara": "巴巴拉",
            "Barbie": "芭比",
            "Bob": "宝伯",
            "Bruce": "布鲁斯",
            "Buddy": "巴迪",
            "Cabbage Dog": "菜狗",
            "Carrot": "卡洛特",
            "Coco": "鳄霸",
            "Curtis": "柯蒂斯",
            "Dodo": "豆豆",
            "Dundun": "嘟嘟",
            "Fluffy": "毛毛",
            "Fubao": "福宝",
            "Fuguee": "福吉",
            "Garfat": "加肥",
            "Googoo": "咕咕",
            "Gopher": "高非",
            "Hachi": "八公",
            "Hammer": "锤子",
            "Harry": "阿瓜",
            "Hoot": "糊涂",
            "Kato": "卡托",
            "Kiko": "希子",
            "Kola": "可乐",
            "Levi": "利威尔",
            "Lloyd": "阿呆",
            "Logan": "罗根",
            "Lotus": "阿宝",
            "Lou": "珞珞",
            "Lamar": "坨坨",
            "Macchiato": "玛奇朵",
            "Maneki": "玛奈奇",
            "Max": "麦克斯",
            "Milky": "妙妙",
            "Moonmoon": "木木",
            "Morse": "莫斯",
            "Miu": "苗苗",
            "Naru": "纳鲁",
            "Nemo": "尼莫",
            "Noodle": "面条",
            "Om Nom": "奥姆诺姆",
            "Ori": "奥里",
            "Otta": "瓦特",
            "Pensky": "哈士企",
            "Raven": "瑞文",
            "Roach": "萝卜",
            "Ron": "罗恩",
            "Sam": "山姆",
            "Shin": "小新",
            "Snow": "雪诺",
            "Skipper": "扣扣",
            "Sparky": "斯帕奇",
            "Spike": "刺头",
            "Stella": "斯黛拉",
            "Sunday": "星期天",
            "Sunny": "桑尼",
            "The Lamb": "咩咩",
            "Tiagra": "泰哥",
            "Tuskarr": "图斯卡尔",
            "Tyrex": "泰雷斯",
            "Underbite": "地包天",
            "Uni": "暴莉",
            "Valiente": "瓦力",
            "Yurusa": "优罗莎",
        }
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;